import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';

import { TOLL_EXTRAORDINARY_ASSIGNMENT_ENDPOINT } from '../../config/endpoints';
import { TOLL_EXTRAORDINARY_ASSIGNMENT_PATH } from '../../config/paths';

import {
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
  DEFAULT_PUT_CONFIG,
  DEFAULT_DELETE_CONFIG,
} from '../../config/rest';

import { isErrorResponse } from '../../utils/error-handlers';

import {
  FLAG_GETTING_TOLL_EXTRAORDINARY_ASSIGNMENTS,
  GET_TOLL_EXTRAORDINARY_ASSIGNMENTS,
  CLEAR_TOLL_EXTRAORDINARY_ASSIGNMENTS,
  FLAG_TOLL_EXTRAORDINARY_ASSIGNMENT_ACTIVITY,
  GET_TOLL_EXTRAORDINARY_ASSIGNMENT,
  CLEAR_TOLL_EXTRAORDINARY_ASSIGNMENT,
} from '../types';

const flagGettingTollExtraordinaryAssignments = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_TOLL_EXTRAORDINARY_ASSIGNMENTS,
    payload: flag,
  });

const getTollExtraordinaryAssignments =
  (tableFilters = {}) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingTollExtraordinaryAssignments(true));

      const queryString = QueryString.stringify(tableFilters);
      const url = queryString
        ? `${TOLL_EXTRAORDINARY_ASSIGNMENT_ENDPOINT}?${queryString}`
        : TOLL_EXTRAORDINARY_ASSIGNMENT_ENDPOINT;

      const response = await fetch(url, DEFAULT_GET_CONFIG);

      await isErrorResponse(response, null, dispatch);

      const tollExtraordinaryAssignments = await response.json();

      dispatch({
        type: GET_TOLL_EXTRAORDINARY_ASSIGNMENTS,
        payload: tollExtraordinaryAssignments,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingTollExtraordinaryAssignments(false));
    }
  };

const clearTollExtraordinaryAssignments = () => (dispatch) =>
  dispatch({
    type: CLEAR_TOLL_EXTRAORDINARY_ASSIGNMENTS,
  });

const flagTollExtraordinaryAssignmentActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_TOLL_EXTRAORDINARY_ASSIGNMENT_ACTIVITY,
    payload: flag,
  });

const getTollExtraordinaryAssignment =
  ({ tollExtraordinaryAssignmentId }) =>
  async (dispatch) => {
    try {
      dispatch(flagTollExtraordinaryAssignmentActivity(true));

      const url = `${TOLL_EXTRAORDINARY_ASSIGNMENT_ENDPOINT}/${tollExtraordinaryAssignmentId}`;
      const response = await fetch(url, DEFAULT_GET_CONFIG);

      await isErrorResponse(response, null, dispatch);

      const tollExtraordinaryAssignment = await response.json();

      dispatch({
        type: GET_TOLL_EXTRAORDINARY_ASSIGNMENT,
        payload: tollExtraordinaryAssignment,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagTollExtraordinaryAssignmentActivity(false));
    }
  };

const clearTollExtraordinaryAssignment = () => (dispatch) =>
  dispatch({
    type: CLEAR_TOLL_EXTRAORDINARY_ASSIGNMENT,
  });

const postTollExtraordinaryAssignment =
  ({ serviceTypeIds, routeId, startDate, endDate, tollIds }) =>
  async (dispatch) => {
    try {
      dispatch(flagTollExtraordinaryAssignmentActivity(true));

      const payload = {
        serviceTypeIds,
        routeId,
        startDate,
        endDate,
        tollIds,
      };

      const response = await fetch(TOLL_EXTRAORDINARY_ASSIGNMENT_ENDPOINT, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });

      await isErrorResponse(response, null, dispatch);

      await response.json();

      toastr.success(
        'Éxito',
        'El peaje extraordinario asignado fue creado correctamente',
      );

      dispatch(push(TOLL_EXTRAORDINARY_ASSIGNMENT_PATH));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagTollExtraordinaryAssignmentActivity(false));
    }
  };

const putTollExtraordinaryAssignment =
  (
    tollExtraordinaryAssignmentId,
    { serviceTypeIds, routeId, startDate, endDate, tollIds },
  ) =>
  async (dispatch) => {
    try {
      dispatch(flagTollExtraordinaryAssignmentActivity(true));

      const payload = {
        serviceTypeIds,
        routeId,
        startDate,
        endDate,
        tollIds,
      };

      const url = `${TOLL_EXTRAORDINARY_ASSIGNMENT_ENDPOINT}/${tollExtraordinaryAssignmentId}`;

      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });

      await isErrorResponse(response, null, dispatch);

      toastr.success(
        'Éxito',
        'El peaje extraordinario asignado fue actualizado correctamente',
      );

      dispatch(
        push(
          `${TOLL_EXTRAORDINARY_ASSIGNMENT_PATH}/${tollExtraordinaryAssignmentId}`,
        ),
      );
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagTollExtraordinaryAssignmentActivity(false));
    }
  };

const deleteTollExtraordinaryAssignment =
  ({ tollExtraordinaryAssignmentId }) =>
  async (dispatch) => {
    try {
      dispatch(flagTollExtraordinaryAssignmentActivity(true));

      const url = `${TOLL_EXTRAORDINARY_ASSIGNMENT_ENDPOINT}/${tollExtraordinaryAssignmentId}`;

      const response = await fetch(url, DEFAULT_DELETE_CONFIG);

      await isErrorResponse(response, null, dispatch);

      toastr.success(
        'Éxito',
        'El peaje extraordinario asignado fue eliminado correctamente',
      );

      dispatch(push(TOLL_EXTRAORDINARY_ASSIGNMENT_PATH));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagTollExtraordinaryAssignmentActivity(false));
    }
  };

export {
  flagGettingTollExtraordinaryAssignments,
  getTollExtraordinaryAssignments,
  clearTollExtraordinaryAssignments,
  flagTollExtraordinaryAssignmentActivity,
  getTollExtraordinaryAssignment,
  clearTollExtraordinaryAssignment,
  postTollExtraordinaryAssignment,
  putTollExtraordinaryAssignment,
  deleteTollExtraordinaryAssignment,
};
